import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    height: "80%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
